import { TransactionsContainer } from '../../containers';

export const Transactions = () => <TransactionsContainer />;
